import React from 'react';

import MyAccount from '@/src/account/components/MyAccount';
import MyCommittees from '@/src/account/components/MyComittees';
import Container from '@/src/shared/components/Container';
import Layout from '@/src/shared/components/Layout';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import withAuthentication from '@/src/shared/components/WithAuthentication';
import FullProfileProvider from '@/src/shared/utils/FullProfileProvider';

const MyCommitteesPage = props => {
  return (
    <Layout>
      <Section bgColor="gray" halfPad>
        <Container>
          <MyAccount
            mainContent={
              <FullProfileProvider>
                <MyCommittees />
              </FullProfileProvider>
            }
          />
          <WebLogImage path="/account/my-committees" title="My Committees" />
        </Container>
      </Section>
    </Layout>
  );
};

export default withAuthentication(MyCommitteesPage);
